import { CollapsableCard } from '@app/app/_components/CollapsableCard/CollapsableCard';
import { CollapsablePanel } from '@app/app/_components/CollapsablePanel/CollapsablePanel';
import { ReadOnlyField } from '@app/app/_components/ReadOnlyField/ReadOnlyField';
import { TextButton } from '@app/app/_components/TextButton/TextButton';
import { FormState } from '@app/lib/form/contracts/FormState';
import { PurchaseLifeInsuranceResult } from '@app/service/eshop/life/actions/purchaseLifeInsurance';
import { useTranslations } from 'next-intl';

interface Props {
    formState: FormState<PurchaseLifeInsuranceResult>;
    handleEditBeneficiaries: () => void;
}

export function FavoredPersonsCard({ formState, handleEditBeneficiaries }: Props) {
    const t = useTranslations();

    return (
        <CollapsableCard defaultCollapsed={false} className="p-6" label={t('eshop.life.favoredPersons')}>
            {formState.data?.formData.beneficiaries.map(beneficiary => (
                <CollapsablePanel
                    key={beneficiary.personalCode}
                    label={beneficiary.name}
                    addon={
                        <TextButton color="primary" preventDefault onClick={handleEditBeneficiaries}>
                            {t('eshop.life.iWillChange')}
                        </TextButton>
                    }
                    collapsable={false}>
                    <div className="grid w-full grid-cols-2 gap-4 py-4">
                        <ReadOnlyField label={t('general.personalCode')}>{beneficiary.personalCode}</ReadOnlyField>
                        <ReadOnlyField label={t('eshop.general.phoneNumberLabel')}>{beneficiary.phone}</ReadOnlyField>
                        <ReadOnlyField label={t('eshop.life.phoneOrEmail')} labelClassName="truncate">
                            {beneficiary.email || beneficiary.phone}
                        </ReadOnlyField>
                        <ReadOnlyField label={t('eshop.life.distribution')}>
                            {`${beneficiary.share * 100}%`}
                        </ReadOnlyField>
                    </div>
                </CollapsablePanel>
            ))}
        </CollapsableCard>
    );
}
